import bridgemateAPI from '../../../apis/bridgemate-apigateway'
import axios from 'axios';
import { S3_ENDPOINT } from '../../../apis/endpoints'
import { uploadTypes } from '../../helpers/AppConsts'
import { indexOfMonth} from '../../helpers/DateUtils'

// Sanitize string for use in filename - removes special chars and replaces spaces
const sanitizeForFilename = (str) => {
    if (!str) return 'unknown';
    return str
        .toLowerCase()
        .replace(/[^a-z0-9\s-]/g, '') // Remove special characters
        .replace(/\s+/g, '-')          // Replace spaces with hyphens
        .replace(/-+/g, '-')           // Replace multiple hyphens with single
        .trim();
};

export const uploadArtifact = (files, event, action, uploadType, onProgress) => {

    const { event_date: eventDate,
            event_club: club,
            event_year: year,
            event_month: month,
            event_day: day } = event;

    var file = files[0];
    if (!file) {
        if (onProgress) onProgress({ status: 'error', message: 'No file selected' });
        return;
    }

    var monthIndex = indexOfMonth(month);
    if (monthIndex === -1) monthIndex = 0; // Fallback if month not found

    const sanitizedClub = sanitizeForFilename(club);

    let fileNameModified;
    if (uploadType === uploadTypes.RESULTS_UPLOAD) {
        fileNameModified = `${sanitizedClub}-${year}-${monthIndex}-${day}-${Date.now()}-results.html`;
    } else if (uploadType === uploadTypes.HANDS_UPLOAD) {
        fileNameModified = `${sanitizedClub}-${year}-${monthIndex}-${day}-${Date.now()}-hands.html`;
    } else if (uploadType === uploadTypes.IMAGE_UPLOAD) {
        fileNameModified = `${sanitizedClub}-${year}-${monthIndex}-${day}-${Date.now()}-image.png`;
    } else if (uploadType === uploadTypes.WINNERS_UPLOAD) {
        fileNameModified = `${sanitizedClub}-${year}-${monthIndex}-${day}-${Date.now()}-winners.html`;
    }

    if (onProgress) onProgress({ status: 'uploading', message: 'Uploading file...' });

    bridgemateAPI.post('/event/upload', {
        filename: fileNameModified,
        filetype: file.type
    }).then(function(url) {
        var options = { headers: { 'Content-Type': file.type }};

        axios.put(url.data, file, options).then(function (response) {
            let endpoint = S3_ENDPOINT + '/' + fileNameModified;

            if (uploadType === uploadTypes.HANDS_UPLOAD) {
                event.event_hands = endpoint;
            } else if (uploadType === uploadTypes.RESULTS_UPLOAD) {
                event.event_results = endpoint;
            } else if (uploadType === uploadTypes.WINNERS_UPLOAD) {
                event.event_winners = endpoint;
            } else if (uploadType === uploadTypes.IMAGE_UPLOAD) {
                event.event_img = endpoint;
            }

            event.registered_players = ["placeholder"];
            event.event_date = eventDate;

            if (onProgress) onProgress({ status: 'success', message: 'Upload complete!', url: endpoint });

            action(event);
        })
        .catch(function (error) {
            console.error('Upload to S3 failed:', error);
            if (onProgress) onProgress({ status: 'error', message: 'Failed to upload file. Please try again.' });
        });
    }).catch(function (error) {
        console.error('Failed to get upload URL:', error);
        if (onProgress) onProgress({ status: 'error', message: 'Failed to initiate upload. Please try again.' });
    });
}
